import { render, staticRenderFns } from "./activity-details.vue?vue&type=template&id=0582debe&scoped=true"
import script from "./activity-details.vue?vue&type=script&lang=js"
export * from "./activity-details.vue?vue&type=script&lang=js"
import style0 from "./activity-details.vue?vue&type=style&index=0&id=0582debe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0582debe",
  null
  
)

export default component.exports